import { Component, OnInit } from '@angular/core';

/**
 * Purpose: This component is used to display a badge that indicates that the item is new.
 */
@Component({
  selector: 'me-is-new-badge',
  templateUrl: './is-new-badge.component.html',
  styleUrls: ['./is-new-badge.component.css']
})
export class IsNewBadgeComponent implements OnInit {
  isNew = false;

  ngOnInit() {
    this.isNew = new Date() < new Date('10-10-2024');
  }

}
